import dynamic from "next/dynamic";
import EmbeddedBoardIframeConfig from "./embedded-board-iframe-config";
import EmbeddedBoardIframeAdvancedConfig from "./embedded-board-iframe-advanced-config";
const EmbeddedBoardIframeComponent = dynamic(()=>import("./embedded-board-iframe-component"));
export default {
    EmbeddedBoardIframeComponent,
    EmbeddedBoardIframeConfig,
    EmbeddedBoardIframeAdvancedConfig
};
